export const EMPTY_SEARCH_FIELD = { key: '', label: '', value: '' };
export const EMPTY_CATEGORY = { title: '', count: '', imageUrl: '' };

// The homepage "Travel Categories" grid fits exactly 4 cards.
export const MAX_FEATURED_HOLIDAY_TYPES = 4;
// Destinations revealed when a homepage category card is expanded, and listed on
// /holidays/:slug. Mirrors the API cap in homepage.controller.js and the website's MAX_DESTS;
// 24 clears the largest real holiday type (Stedentrips, 21 linked countries).
export const MAX_FEATURED_DESTINATIONS = 24;
export const EMPTY_FEATURED_HOLIDAY_TYPE = {
  holidayTypeId: null,
  title: '',
  imageUrl: '',
  active: true,
  destinations: [],
  // Master §12B.3: optional date range on the travel START date (off = no effect).
  enableDateRange: false,
  startDate: '',
  endDate: '',
};
export const EMPTY_DEST_TAB = { tab: '', cards: [] };
export const EMPTY_DEST_CARD = { name: '', holidays: '', imageUrl: '', badge: '' };
export const EMPTY_STAT = { value: '', label: '' };
export const EMPTY_VACATION = {
  label: '',
  title: '',
  description: '',
  imageUrl: '',
  buttonText: 'Explore',
};
// The homepage "Popular with our holidaymakers" row shows 5 hotel cards.
export const MAX_POPULAR_HOTELS = 5;
export const EMPTY_HOTEL = { hotelId: null, name: '', location: '', price: '', score: '', stars: 5, imageUrl: '' };
export const EMPTY_GROUP = { title: '', count: '', links: [] };
export const EMPTY_TRUST = { title: '', description: '', url: '' };
export const EMPTY_REVIEW = { name: '', date: '', text: '', score: '', avatarUrl: '' };
export const EMPTY_AWARD = { title: '', year: '' };

// ── "Favorite type of vacation" card filters ────────────────────────────────
// One-click presets covering everything the client asked for. Every code below was read
// out of `facilityTypes` against the live database — none may be edited or extended from
// memory, because a wrong code does not error, it silently returns the wrong hotels.
//
// Activities are stored group-qualified ("74:620") because the catalogue REUSES codes
// across groups: 620 is Spa centre in group 74 and Waterpark in group 73, 410 is Hot tub
// in 74 and Surfing in 90. Qualifying is also the only way to reach group 71 (Catering),
// where the swim-up bar lives. Facilities/kids/accommodation stay bare: their SQL already
// pins a single group.
//
// "Jacuzzi / Hot tub" is deliberately one button — the catalogue has no separate Jacuzzi
// entry, both names map to 74:410.
export const VACATION_FILTER_PRESETS = [
  { label: 'All Inclusive',     filterKey: 'boards',     value: 'AI' },
  { label: 'Half Board',        filterKey: 'boards',     value: 'HB' },
  { label: 'Full Board',        filterKey: 'boards',     value: 'FB' },
  { label: 'Bed & Breakfast',   filterKey: 'boards',     value: 'BB' },
  { label: 'Room Only',         filterKey: 'boards',     value: 'RO' },
  { label: '3-star',            filterKey: 'stars',      value: 3 },
  { label: '4-star',            filterKey: 'stars',      value: 4 },
  { label: '5-star',            filterKey: 'stars',      value: 5 },
  { label: 'Adults only',       filterKey: 'adultsOnly', value: true },
  { label: 'Private beach',     filterKey: 'facilities', value: 574 },
  { label: 'Spa centre',        filterKey: 'activities', value: '74:620' },
  { label: 'Jacuzzi / Hot tub', filterKey: 'activities', value: '74:410' },
  { label: 'Swim-up bar',       filterKey: 'activities', value: '71:570' },
  { label: 'Golf',              filterKey: 'activities', value: '90:390' },
  { label: 'Football',          filterKey: 'activities', value: '90:540' },
  { label: "Kids' club",        filterKey: 'kids',       value: 340 },
];

// The destinations the website searches when the visitor has not picked one. The editor's
// match count has to be measured over exactly this scope, or the number shown here is not
// the number the card will actually produce. Mirrors DEFAULT_DESTINATIONS in Results.jsx.
export const VACATION_COUNT_SCOPE = ['PMI', 'TFS', 'AGP', 'AYT', 'RAK', 'LPA', 'HRG', 'ALC'];

// A card leading to fewer hotels than this reads as broken on the homepage even though the
// link works. Football (314 hotels worldwide) is the case this exists to catch.
export const VACATION_LOW_MATCH = 25;

export const BADGE_NONE_VALUE = '__BADGE_NONE__';
export const BADGE_CUSTOM_VALUE = '__BADGE_CUSTOM__';
export const DESTINATION_BADGE_PRESET_OPTIONS = [
  { label: 'Best Seller', value: 'Best Seller' },
  { label: 'Trending', value: 'Trending' },
  { label: 'Family Favorite', value: 'Family Favorite' },
  { label: 'Limited Time', value: 'Limited Time' },
  { label: 'Hot Deal', value: 'Hot Deal' },
  { label: 'New', value: 'New' },
];
export const DESTINATION_BADGE_OPTIONS = [
  { label: 'No Badge', value: BADGE_NONE_VALUE },
  ...DESTINATION_BADGE_PRESET_OPTIONS,
  { label: 'Custom (type your own)', value: BADGE_CUSTOM_VALUE },
];
